import React, { useState, useEffect, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'

import { updateExistingCompanyAct } from 'redux/actions/companies'
import Nixi1Spinner from 'components/Nixi1Spinner'
import ModalAlert from 'components/ModalAlert'
import PlanAPI from 'api/plans'

import './styles.scss'
import PlanPriceCard from './PlanPriceCard'

/**
 * Plan price selctor
 * @param {object} props
 * @param {function} props.onChange
 */
const PlanPriceSelector = (props) => {
  const { onChange } = props

  const dispatch = useDispatch()
  const {
    identifier: planIdentifier, companyPlan: plan
  } = useSelector(store => store.currentPlan)

  const [loading, setLoading] = useState(true)
  const [disabled, setDisabled] = useState(false)
  const [plans, setPlans] = useState([])
  const [state, setState] = useState({ identifier: planIdentifier, plan })
  const [error, setError] = useState(null)

  useEffect(() => {
    PlanAPI.getAvailable()
      .then((data) => {
        setPlans(data.plans)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const onChangePlan = useCallback((plan) => {
    setState({
      plan: plan.companyPlan,
      identifier: plan.identifier
    })
  }, [])

  const onSubmit = useCallback(async () => {
    try {
      setDisabled(true)

      const data = await PlanAPI.changePlan({
        identifier: state.identifier
      })

      dispatch(updateExistingCompanyAct(data.company))
      setDisabled(false)

      if (onChange) onChange(null, data)
    } catch (error) {
      const { data } = error
      if (data.type) setError(data)
      setDisabled(false)

      if (onChange) onChange(error)
    }
  }, [onChange, dispatch, state])

  return (
    <div className='plan_price_selector'>
      <div className='plan_price_selector-title'>
        {I18n.t('select_payment_plan')}
      </div>

      <div
        className={`plan_price_selector-container ${loading ? 'plan_price_selector-loader': ''}`}
      >
        {
          loading
            ? <Nixi1Spinner width='30px' height='30px' />
            : (
              plans.map(elem => (
                <PlanPriceCard
                  key={elem.identifier}
                  plan={elem}
                  isCurrent={planIdentifier === elem.identifier}
                  isSelected={state.identifier === elem.identifier}
                  onChange={onChangePlan}
                />
              ))
            )
        }
      </div>

      {
        planIdentifier !== state.identifier
          ? (
            <div className='plan_price_selector-container_btn'>
              <Button
                type='button'
                disabled={disabled}
                color='primary'
                onClick={onSubmit}
              >
                {I18n.t('dashboard_save')}
              </Button>
            </div>
          )
          : null
      }

      {
        error
          ? (
            <ModalAlert
              isOpen={!!error}
              header={I18n.t('price_plan_popup_title')}
              text1={I18n.t('price_plan_popup_subtitle')}
              text2={I18n.t(error.type)}
              toggle={() => setError(null)}
            />
          )
          : null
      }
    </div>
  )
}

export default PlanPriceSelector